
import Vue from 'vue';
export default Vue.extend({
  props: {
    contacts: {
      type: Array as () => Array<any>,
    },
  },
  async fetch() {
    // Prefetch segments and roles data since ContactItem components will need them
    if (this.contacts && this.contacts.length > 0) {
      await Promise.all([this.$loadDataSource('segment'), this.$loadDataSource('job-rollen')]);
    }
  },
});
